// apps/web/src/core/config/constants.ts

/**
 * 本地存储键名常量
 */
export const STORAGE_KEYS = {
    PROMPT_STORE: 'prompt-store',
    MODEL_STORE: 'model-settings',
    TEMPLATES: 'templates',
    MEMORY_STORE: 'memory-store'
};